import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import {
    Modal,
    ModalComponent,
    ModalProps,
    ModalsProvider,
    Typography,
} from '@speeki/global-ui-components';

import { useReportDetails } from '@utils/hooks/useReportDetails';
import { useResponsive } from '@utils/hooks/useResponsive';

import {
    CloseButton,
    DetailsName,
    DetailsWrapper,
    ModalContent,
} from './ReportDetailsModal.styled';

interface ReportDetailsModalProps
    extends Pick<ModalProps, 'onClose' | 'open'> {}

export const ReportDetailsModal = ({
    onClose,
    open,
}: ReportDetailsModalProps) => {
    const { t } = useTranslation();
    const isMd = useResponsive('md');

    const { additionalDetails, excludedManagers } = useReportDetails();

    useEffect(() => {
        if (!isMd && open) ModalsProvider.close('ReportDetailsModal');
    }, [isMd]);

    return (
        <ModalComponent onClose={onClose} open={open} width={458}>
            <ModalContent>
                <CloseButton
                    iconProps={{ icon: 'SvgCloseBig24', size: 24 }}
                    onClick={onClose}
                    testId="nPweYn1"
                />

                <Modal.TitleSecondary center>
                    {t('REPORT_DETAILS')}
                </Modal.TitleSecondary>
                {!!additionalDetails.length && (
                    <DetailsWrapper>
                        {additionalDetails.map((detail) => (
                            <div key={detail.key}>
                                <DetailsName>{detail.title}</DetailsName>
                                <Typography.TextBody_16_24>
                                    {detail.value}
                                </Typography.TextBody_16_24>
                            </div>
                        ))}
                        {excludedManagers && (
                            <div>
                                <DetailsName>
                                    {t('ADDITIONAL_DETAILS_MANAGERS')}
                                </DetailsName>
                                <Typography.TextBody_16_24>
                                    {excludedManagers.join(', ')}
                                </Typography.TextBody_16_24>
                            </div>
                        )}
                    </DetailsWrapper>
                )}
            </ModalContent>
        </ModalComponent>
    );
};
